/**
 * 방화벽 정책 셋트 store
 * Ipv4, Ipv6
 *
 * @since 2018-06-05
 * @author kdydesign.kim
 */

import {SecutiryPolicyApiPrefix as objApiPrefix} from 'utils'

export const state = () => ({
  version: 4,
  policySetList: []
})

export const mutations = {
// 방화벽 IP Version 설정
  setIpVersion (state, version) {
    state.version = version
  },

  // 정책 셋트 조회
  getPolicySet (state, data) {
    state.policySetList = data
  },

  // 정책 셋트 추가
  setPolicySet (state, data) {
    state.policySetList.push(data)
  },

  // 정책 셋트 추가 - 정책에서의 임시 저장 시
  setTempStoragePolicySet (state, data) {
    state.policySetList = _.map(state.policySetList, (o) => {
      o.use = 0

      return o
    })

    state.policySetList.push(data)
  },

  // 정책 셋트 삭제
  deletePolicySet (state, data) {
    const policySetList = state.policySetList
    const itemIndex = _.indexOf(policySetList, data)

    policySetList.splice(itemIndex, 1)
  },

  // 정책 셋트 열기
  openPolicySet (state, data) {
    state.policySetList = _.map(state.policySetList, (o) => {
      if (o.fw_set_id === data.fw_set_id) {
        o = data
      } else {
        _.assign(o, {use: 0})
      }
      return o
    })
  }
}

export const actions = {
  // 방화벽 IP Version 설정
  setIpVersion ({commit}, {version}) {
    commit('setIpVersion', version)
  },

  // 정책 셋트 조회
  async getPolicySet ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/fw/${state.version}/sets`)

    if (code === 'ok') {
      commit('getPolicySet', result)
    }
  },

  // 다른 이름으로 저장
  async saveAsPolicySet ({commit, state}, {name}) {
    const openSetId = _.find(state.policySetList, {use: 1}).fw_set_id
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/fw/${state.version}/sets/${openSetId}`, {
      fw_set_new_name: name
    }, {
      alertMsg: window.$nuxt.$t('msg.addApply')
    })

    if (code === 'ok') {
      commit('setPolicySet', result)

      return result
    }
  },

  // 정책 셋트 추가
  async setPolicySet ({commit, state}, firewallPolicySettings) {
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/fw/${state.version}/sets`, firewallPolicySettings, {
      successAlert: false,
      loadingHide: false
    })

    if (code === 'ok') {
      commit('setPolicySet', result)

      return result
    }
  },

  // 정책 셋트 삭제
  async deletePolicySet ({commit, state}, policySet) {
    const {code} = await this.$axios.$delete(`${objApiPrefix}/fw/${state.version}/sets/${policySet.fw_set_id}`)

    if (code === 'ok') {
      commit('deletePolicySet', policySet)
    }
  },

  // 정책 셋트 열기
  async openPolicySet ({commit, state}, {policySet, loadingShow = true, loadingHide = true}) {
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/fw/${state.version}/sets/${policySet.fw_set_id}/use`, {use: 1}, {
      successAlert: false,
      loadingShow,
      loadingHide
    })

    if (code === 'ok') {
      commit('openPolicySet', result)
    }
  }
}

export const getters = {
  // 정책 셋트 데이터
  parseGetPolicySet (state) {
    const data = state.policySetList

    const parseData = _.map(data, (o) => {
      if (o.use === 1) {
        o = _.assign(o, {parseUse: window.$nuxt.$t('cmn.used')})
      } else {
        o = _.assign(o, {parseUse: window.$nuxt.$tc('cmn.unUsed', 1)})
      }

      return o
    })

    return parseData
  }

  // 현재 사용중인 정책 셋트
  // getCurrentRuleSet (state) {
  //   const result = _.find(state.policySetList, {use: 1})
  //   if (result) {
  //     return result
  //   } else {
  //     return {
  //       name: ''
  //     }
  //   }
  // }
}

export const strict = false
